export default "__VITE_ASSET__DcwA0_Az__"